import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Command Prompt.
 *
 * Not a singleton — `START` opens another one, which is the whole joke of
 * `start` in a console, and XP let you have as many as you liked.
 *
 * Args:
 *   cwd  string  directory to start in; defaults to the user's profile folder
 *                (`C:\Documents and Settings\<user>`), where cmd.exe opened
 *   path string  accepted as a synonym for `cwd`, so an Explorer-shaped
 *                argument works too
 */
export const cmdApp: AppManifest = {
  id: 'cmd',
  name: 'Command Prompt',
  icon: '/assets/icons/cmd.svg',
  component: lazy(() => import('./Cmd')),

  defaultSize: { w: 660, h: 400 },
  minSize: { w: 320, h: 180 },
  resizable: true,
  maximizable: true,
  singleton: false,

  group: 'Accessories',

  // TITLE re-titles the window at runtime; this is what it starts as.
  titleFor: () => 'Command Prompt',
};
